import { h, Fragment } from "@stencil/core";
import { ApplicationTopicGroup } from "../../../api/publicApi/createCase/applicationTopicOptions";
import { FormStore } from "../stores/formStore";
import { getApplicationOptionsFromForm } from "../../../api/publicApi/createCase/getApplicationOptionsFromForm";
import { PrefillData } from "../../../components";
import { ApiStore } from "../stores/apiStore";
import { getSelectedSubApplications } from "../stores/getSelectedSubApplications";

interface ApplicationSelectProps {
    t: (key: string) => string;
    applicationTopicGroup: ApplicationTopicGroup;
    formStore: FormStore;
    form: HTMLFormElement;
    prefillData?: PrefillData | null;
}

export const ApplicationSelect = ({ t, applicationTopicGroup, formStore, form, prefillData }: ApplicationSelectProps) => (
    <ux-select
        required
        label={applicationTopicGroup.name}
        data-validation-required--msg={t("validation.requiredField")}
        name="application"
        onUxChange={() => {
            formStore.state.selectedApplications = getApplicationOptionsFromForm(form);
        }}
    >
        <option value="" selected disabled>
            {t("select.placeholder")}
        </option>
        {applicationTopicGroup.children.map((application) => (
            <option value={application.id} selected={prefillData?.applicationTopicIds?.includes(application.id)}>
                {application.name}
            </option>
        ))}
    </ux-select>
);

interface ApplicationSelectGroupProps {
    t: (key: string) => string;
    apiStore: ApiStore;
    formStore: FormStore;
    form: HTMLFormElement;
    prefillData?: PrefillData | null;
}

export const ApplicationSelectGroup = ({ t, apiStore, formStore, form, prefillData }: ApplicationSelectGroupProps) => {
    if (!formStore.state.showApplications) {
        return null;
    }
    return apiStore.state.applicationTopicOptions.map((applicationTopicGroup) => (
        <Fragment>
            <div class="ux-row">
                <div class="ux-col-12 ux-col-md-6">
                    <div class="ux-u-margin-bottom-20">
                        <ApplicationSelect
                            t={t}
                            applicationTopicGroup={applicationTopicGroup}
                            formStore={formStore}
                            form={form}
                            prefillData={prefillData}
                        />
                    </div>
                </div>
            </div>
            <div class="ux-row">
                {getSelectedSubApplications(formStore, applicationTopicGroup).map((subApplication) => (
                    <div class="ux-col-12 ux-col-md-6">
                        <div class="ux-u-margin-bottom-20">
                            <ApplicationSelect
                                t={t}
                                applicationTopicGroup={subApplication}
                                formStore={formStore}
                                form={form}
                                prefillData={prefillData}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </Fragment>
    ));
};
